import React from 'react';
import { Empty, Tabs } from 'antd';
import { IPipelineRun } from '../../../../core/modules/pipelines/pipelines.model';
import { flattenForTab, liveRunForActivity } from '../../utils/runHistory';
import RunHistoryTable from '../RunHistoryTable';
import StatStrip from '../StatStrip';

const { TabPane } = Tabs;

interface IActivityTabsProps {
  runs: IPipelineRun[];
  current: IPipelineRun | null;
  emptyDescription?: string;
}

/** Per-activity tab strip shared by Durable + Function detail views. */
const ActivityTabs: React.FC<IActivityTabsProps> = ({
  runs,
  current,
  emptyDescription = 'No recent runs'
}) => {
  if (runs.length === 0) {
    return <Empty description={emptyDescription} />;
  }

  return (
    <Tabs size='small'>
      {runs.map((parent) => {
        const flat = flattenForTab(parent);
        const live = liveRunForActivity(parent.activityName, current);
        const tabRuns = live ? [live, ...flat] : flat;
        const headRun = live ?? parent;
        const key = parent.activityName || parent.runId || 'unknown';

        return (
          <TabPane tab={parent.activityName || '—'} key={key}>
            <StatStrip current={headRun} runs={tabRuns} showStages={false} />
            <RunHistoryTable runs={tabRuns} showActivityColumn={false} />
          </TabPane>
        );
      })}
    </Tabs>
  );
};

export default ActivityTabs;
